import { TimeFrameKey } from 'data/time-frames';
import { Language } from 'store/slices/language-slice';
import { formatCurrency } from 'utils/currencies';
import { getRelativeTimeframeLabel } from 'utils/time-frames';
export interface PortfolioTranslations {
  seo: {
    title: string;
    description: string;
    keywords: string;
  };
  portfolioSummary: {
    amount: string;
    totalHeading: string;
    cashBalance: string;
    reservedHoldings: string;
    reservedAssets: string;
    deposit: string;
    withdraw: string;
    subHeading: (
      totalGainValue: number,
      totalGainPercentage: number,
      timeFrame: TimeFrameKey,
      baseCurrencyCode: string,
    ) => string;
    assetsPendingWithdrawal: string;
  };
  holdings: {
    annualYield: string;
  },
  overTimePeriod: Record<TimeFrameKey, string>;
  portfolioPerformance: string;
}

type Messages = {
  [key in Language]: PortfolioTranslations;
};

const messages: Messages = {
  en: {
    seo: {
      title: 'Altify - Portfolio',
      description:
        'Effortlessly invest in crypto with one of our Bundles. Investing has never been this easy.',
      keywords:
        'investing, investment platform, cryptocrurency, top 10 cryptocurrency, top cryptocurrency, top performing crypto, diversification, diversified investing',
    },
    portfolioSummary: {
      amount: 'Amount',
      totalHeading: 'Total Portfolio Value',
      cashBalance: 'Cash balance',
      reservedHoldings: 'Reserved holdings',
      reservedAssets: 'Reserved Assets',
      deposit: 'Deposit',
      withdraw: 'Withdraw',
      subHeading: (
        totalGainValue: number,
        totalGainPercentage: number,
        timeFrame: TimeFrameKey,
        baseCurrencyCode: string,
        // TODO: re-add formatPercentage when catered for value being correct %
      ) => {
        const sign = totalGainPercentage > 0 ? '+' : '-';

        return `You're ${totalGainPercentage > 0 ? 'up' : 'down'} ${formatCurrency(
          Math.abs(totalGainValue),
          baseCurrencyCode as string,
        )} (${sign}${Math.abs(totalGainPercentage).toFixed(
          2,
        )}%) ${getRelativeTimeframeLabel(timeFrame)}`;
      },
      assetsPendingWithdrawal:
        'These assets are currently being\nprocessed for withdrawal',
    },
    portfolioPerformance: 'Portfolio Performance',
    overTimePeriod: {
      '24h': 'over 24 hours',
      "7d": 'over 7 days',
      '1m': 'over 1 month',
      '3m': 'over 3 months',
      '1y': 'over 1 year',
      all: 'all-time return',
    },
    holdings: {
      annualYield: 'Annual Yield'
    }
  },
};

export default messages;
